<template>
  <div class="news-home" v-if="featured">
    <div class="news-home__inner">
      <div class="news-home__head">
        <h2 class="news-home__title">{{ t.title }}</h2>
        <a class="news-home__viewall" :href="newsListUrl" :data-label="`${t.viewAll}`">
          <span>{{ t.viewAll }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M5 12h14"/>
            <path d="M13 6l6 6-6 6"/>
          </svg>
        </a>
      </div>

      <div class="news-home__wrap">
        <!-- Noticia destacada -->
        <article v-if="featured" class="news-feature">
          <a
            class="news-feature__media"
            :href="featured.href"
            :target="featured.target"
            :title="featured.title"
            :data-label="`${featuredCta} - ${featured.title}`"
          >
            <img v-if="featured.image" :src="featured.image" :alt="featured.imageAlt" />
          </a>
          <div class="news-feature__body">
            <span v-if="featured.category" class="news-feature__cat">{{ featured.category }}</span>
            <h3 class="news-feature__headline">{{ featured.title }}</h3>
            <p v-if="featured.excerpt" class="news-feature__excerpt">{{ featured.excerpt }}</p>
            <a
              class="news-feature__cta"
              :href="featured.href"
              :target="featured.target"
              :title="featured.title"
              :data-label="`${featuredCta} - ${featured.title}`"
            >
              <span>{{ featuredCta }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M5 12h14"/>
                <path d="M13 6l6 6-6 6"/>
              </svg>
            </a>
          </div>
        </article>

        <!-- Top 5 (lista compacta) -->
        <ul class="news-list">
          <li v-for="n in listItems" :key="n.id" class="news-item">
            <a
              class="news-item__link"
              :href="n.href"
              :target="n.target"
              :title="n.title"
              :data-label="`${n.cta} - ${n.title}`"
            >
              <span class="news-item__thumb">
                <img v-if="n.image" :src="n.image" :alt="n.imageAlt" />
              </span>
              <span class="news-item__c">
                <span v-if="n.category" class="news-item__cat">{{ n.category }}</span>
                <span class="news-item__headline">{{ n.title }}</span>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapNewsItem } from '../helpers/newsHelpers';

export default {
  name: 'NewsHome',
  props: {
    // Data cruda de Prismic (array de documentos clc_news).
    news: {
      type: Array,
      default: () => []
    },
    prismicLang: {
      type: String,
      required: true,
      validator: (value) => ['en-us', 'es-es'].includes(value)
    },
    // Segmento del centro actual (para preservar ?center= en los links).
    clcSegmentValue: {
      type: String,
      default: ''
    },
    // Texto del CTA de la noticia destacada (desde clc_new_home_page > highlighted_new_cta_text).
    // Vacío -> default localizado ("Learn more" / "Ver más").
    featuredCtaLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    t() {
      const texts = {
        'en-us': { title: 'News & Updates', viewAll: 'View all News' },
        'es-es': { title: 'Noticias y Actualizaciones', viewAll: 'Ver todas las noticias' }
      };
      return texts[this.prismicLang] || texts['en-us'];
    },
    // CTA de la destacada: texto cargado en Prismic, o default localizado si viene vacío.
    featuredCta() {
      const label = typeof this.featuredCtaLabel === 'string' ? this.featuredCtaLabel.trim() : '';
      if (label) return label;
      return this.prismicLang === 'es-es' ? 'Ver más' : 'Learn more';
    },
    mapped() {
      // Las noticias vienen ya CURADAS y ORDENADAS desde la Home (featured_news en Prismic).
      // El orden del picker manda; no se filtra por body (la inclusión la decide el editor).
      return (this.news || []).map(item => mapNewsItem(item, this.prismicLang, this.clcSegmentValue));
    },
    featured() {
      // La 1ª del picker es la destacada (grande). Sin picks -> null -> el módulo se oculta (v-if="featured").
      return this.mapped[0] || null;
    },
    listItems() {
      // El resto (hasta 5) en la lista compacta, respetando el orden del picker.
      return this.mapped.slice(1, 6);
    },
    newsListUrl() {
      const l = this.prismicLang === 'es-es' ? 'es' : 'en';
      const query = this.clcSegmentValue ? `?center=${this.clcSegmentValue}` : '';
      return `/${l}/news${query}`;
    }
  }
};
</script>
